import type { Deal } from '@/api/types'

/** Won/Lost badge for closed deals — open deals render nothing. */
export default function DealStatusBadge({ status }: { status: Deal['status'] }) {
  if (status !== 'won' && status !== 'lost') return null
  return (
    <span
      className={`text-[10px] font-semibold uppercase rounded px-1.5 py-0.5 ${
        status === 'won' ? 'bg-success/15 text-success' : 'bg-danger/15 text-danger'
      }`}
    >
      {status}
    </span>
  )
}
